
import React from "react";
import MainLayout from "@/layout/MainLayout";

const CookiePolicy: React.FC = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-semibold mb-8">Cookie Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">1. What Are Cookies</h2>
          <p>
            Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to the website owners.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">2. How We Use Cookies</h2>
          <p>We use cookies for the following purposes:</p>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Essential cookies:</strong> These are necessary for the website to function properly.</li>
            <li><strong>Analytical/performance cookies:</strong> These allow us to recognize and count the number of visitors and see how visitors move around our website.</li>
            <li><strong>Functionality cookies:</strong> These are used to recognize you when you return to our website.</li>
            <li><strong>Targeting cookies:</strong> These record your visit to our website, the pages you have visited, and the links you have followed.</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">3. Types of Cookies We Use</h2>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Session cookies:</strong> These are temporary cookies that expire when you close your browser.</li>
            <li><strong>Persistent cookies:</strong> These remain on your device until you delete them or they expire.</li>
            <li><strong>First-party cookies:</strong> These are set by our website.</li>
            <li><strong>Third-party cookies:</strong> These are set by our partners and service providers.</li>
          </ul>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">4. Managing Cookies</h2>
          <p>
            Most web browsers allow you to control cookies through their settings. You can usually find these settings in the "Options" or "Preferences" menu of your browser. You can also set your browser to decline all cookies or to indicate when a cookie is being sent.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">5. Consequences of Disabling Cookies</h2>
          <p>
            If you disable cookies, some features of our website may not function properly. This includes preferences you've set and potentially login sessions.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">6. Changes to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page and updating the "Last updated" date.
          </p>
          
          <h2 className="text-2xl font-medium mb-4 mt-8">7. Contact Us</h2>
          <p>
            If you have any questions about this Cookie Policy, please contact us at privacy@heygail.com.
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default CookiePolicy;
